import { IntegrationPointType } from '../../extensions/types/appExtension';
import { ComponentType } from 'react';

export type AppToolId = BuildInAppToolId | string;

export enum BuildInAppToolId {
    Messages = 'MESSAGES',
    SessionChats = 'SESSION_CHATS',
    Meetings = 'Meetings',
    SupportChat = 'SUPPORT_CHAT',
    SessionExtension = 'SESSION_EXTENSION',
    EventExtension = 'EVENT_EXTENSION',
}

export type AppToolType = BuildInAppToolId | IntegrationPointType;

export interface IAppToolbarItem {
    id: AppToolId;
    extensionId?: string;
    title: string;
    icon: JSX.Element;
    animatedIcon: JSON;
    iconUrl: string;
    isSelected?: boolean;
    isEnabled?: boolean;
    onAppSelected?: (id: AppToolId) => void;
    useNotification?: (params: INotificationParams) => IAppNotification;
    openByDefault?: boolean;
    awareness: IAwareness;
    onItemFinishLoading?: (id: AppToolId, isVisible: boolean) => void;
    trackIconClick?: (id: string, shouldShowNotification: boolean) => void;
}

export interface IAppToolConfig {
    id: AppToolId;
    extensionId?: string;
    type: AppToolType;
    title: string;
    iconUrl?: string;
    isVisible?: () => boolean;
    needSession?: boolean;
    category?: string;
    name?: string;
}

export interface INotificationParams {
    eventUniqueName: string;
}

export interface IAppNotification {
    hasNewNotification: boolean;
    resetNotification: () => void;
    shouldResetNotificationOnSelect?: boolean;
}

export interface IAppToolsContext {
    eventUniqueName: string;
    sessionId: number;
}

export interface IAppToolProps {
    selectedApp: AppToolId;
    extensionId?: string;
    isExpanded?: boolean;
    shouldShowCollapseAnimation?: boolean;
    shouldShowExpandAnimation?: boolean;
}

export interface IAwarenessTooltipProps {
    onClose: () => void;
    onOpenApp: () => void;
}

export interface IAwareness {
    dot: { featureToggleName: string };
    tooltip: IAwarenessTooltip;
}

interface IAwarenessTooltip {
    icon?: JSX.Element;
    title?: string;
    text?: string;
    customComponent?: ComponentType<IAwarenessTooltipProps>;
    featureToggleName: string;
}
